<template>
  <van-tabbar
    v-if="show"
    v-model="active"
    active-color="#e7b58e"
    :border="true"
    inactive-color="#929292"
    style="height: 5rem; border-top: 2px solid #423c3e; z-index: 99"
  >
    <!-- 首页 -->
    <van-tabbar-item
      to="/home"
      :class="active === 0 ? 'bc-router' : 'bc-noroute'"
    >
      <span>{{ $t("foorter.index") }}</span>
      <template #icon>
        <img
          :src="active === 0 ? '/img/footer/indexed.png' : '/img/footer/index.png'"
          style="height: 1.2rem"
        />
      </template>
    </van-tabbar-item>

    <!-- 黑料 / 订阅 -->
    <van-tabbar-item
      to="/history"
      :class="active === 1 ? 'bc-router' : 'bc-noroute'"
    >
      <span>{{ $t("foorter.subscribe") }}</span>
      <template #icon>
        <img
          :src="active === 1 ? '/img/footer/subscribed.png' : '/img/footer/subscribe.png'"
          style="height: 1.2rem"
        />
      </template>
    </van-tabbar-item>

    <!-- 选妃 -->
    <van-tabbar-item
      to="/choose"
      :class="active === 2 ? 'bc-router' : 'bc-noroute'"
    >
      <span>{{ $t("concubine.concubine") }}</span>
      <template #icon>
        <img
          :src="active === 2 ? '/img/footer/choosed.png' : '/img/footer/choose.png'"
          style="height: 1.2rem"
        />
      </template>
    </van-tabbar-item>

    <!-- 投注 【重点：拼接参数】 -->
    <van-tabbar-item
      :to="`/Lottery?key=${gameitem[0]?.key || ''}&id=${gameitem[0]?.id || ''}`"
      :class="active === 3 ? 'bc-router' : 'bc-noroute'"
    >
      <span>{{ $t("foorter.video") }}</span>
      <template #icon>
        <img
          :src="active === 3 ? '/img/footer/videoed.png' : '/img/footer/video.png'"
          style="height: 1.2rem"
        />
      </template>
    </van-tabbar-item>

    <!-- 我的 -->
    <van-tabbar-item
      to="/mine"
      :class="active === 4 ? 'bc-router' : 'bc-noroute'"
    >
      <span>{{ $t("foorter.my") }}</span>
      <template #icon>
        <img
          :src="active === 4 ? '/img/footer/myed.png' : '/img/footer/my.png'"
          style="height: 1.2rem"
        />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0,
      // 接口返回为数组，初始为空数组
      gameitem: []
    };
  },
  props: {
    is_show: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    // 初始化匹配当前页面高亮
    this.setActiveByRoute(this.$route.name);
    // 初始化请求接口，拿到 key id
    this.getGameItem();
    if (this.is_show) {
      this.show = true;
    }
  },
  watch: {
    // 路由切换自动切换tab高亮
    $route(to) {
      this.setActiveByRoute(to.name);
    },
  },
  methods: {
    // 获取彩票默认配置参数
    getGameItem() {
      this.$http({
        method: "get",
        url: "lottery_list",
      }).then((res) => {
        this.gameitem = res.data || [];
      });
    },
    // 根据路由name切换tab
    setActiveByRoute(name) {
      switch (name) {
        case "home":
          this.active = 0;
          this.show = true;
          break;
        case "history":
          this.active = 1;
          this.show = true;
          break;
        case "choose":
          this.active = 2;
          this.show = true;
          break;
        case "Lottery":
          this.active = 3;
          this.show = true;
          break;
        case "mine":
          this.active = 4;
          this.show = true;
          break;
        default:
          this.show = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/base.less";

@tabbar-height: 110px;
@tabbar-img: 40px;

.van-tabbar {
  height: @tabbar-height;
  background-color: @page_bg;
}
.van-tabbar-item--active {
  background-color: @page_bg;
}
.van-tabbar-item__icon img {
  height: @tabbar-img;
}
.van-tabbar-item {
  font-size: 26px;
}
[class*="van-hairline"]::after {
  border: none !important;
}

/* 选中样式 */
.bc-router {
  background: linear-gradient(to bottom, #362c2b, #241d25) !important;
  border-radius: 1rem;
}
.bc-noroute {
  background: none !important;
}
span {
  font-weight: lighter !important;
  font-size: 0.8rem;
}
</style>